import React from 'react';

export const JusanIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.7308 3H5.2692C4.01596 3 3 4.01596 3 5.2692V18.7308C3 19.984 4.01596 21 5.2692 21H18.7308C19.984 21 21 19.984 21 18.7308V5.2692C21 4.01596 19.984 3 18.7308 3Z"
      fill="#FE5000"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.7835 5.99753L13.5971 7.09075C13.0854 7.34657 12.7622 7.86952 12.7622 8.44182V15.8164L14.9482 14.7237C15.4599 14.4674 15.7835 13.9444 15.7835 13.3725V5.99753Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.2513 12.4185L9.06477 13.5117C8.55313 13.7675 8.22998 14.2905 8.22998 14.8628V18.0835L10.416 16.9903C10.9276 16.7343 11.2513 16.2114 11.2513 15.6391V12.4185Z"
      fill="white"
    />
  </svg>
);
